import { ReactElement, SVGProps } from 'react';
import BaseIcon from './BaseIcon';

export default function WandStartIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props} viewBox="0 0 16 16">
      <path
        d="M10.767 8.7 9.333 11a.48.48 0 0 1-.508.233q-.325-.049-.408-.383L7.95 8.983l-4.55 4.55a.65.65 0 0 1-.458.192.62.62 0 0 1-.475-.192.63.63 0 0 1-.184-.466q0-.284.184-.467l4.55-4.567-1.867-.466q-.333-.084-.383-.409A.48.48 0 0 1 5 6.65l2.3-1.417-.2-2.716a.45.45 0 0 1 .267-.484q.3-.15.55.067L10 3.85l2.517-1.017q.316-.133.55.1.232.234.1.55L12.15 6l1.75 2.067q.217.25.067.55t-.484.266zM2.233 4.233a.32.32 0 0 1 0-.466L3.1 2.9a.32.32 0 0 1 .467 0l.866.867a.32.32 0 0 1 0 .466l-.866.867a.32.32 0 0 1-.467 0zm9.534 9.534L10.9 12.9a.32.32 0 0 1 0-.467l.867-.866a.32.32 0 0 1 .466 0l.867.866a.32.32 0 0 1 0 .467l-.867.867a.32.32 0 0 1-.467 0"
        fill="currentColor"
      />
    </BaseIcon>
  )
}
